import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../lib/supabase';

const AdminForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [successMsg, setSuccessMsg] = useState('');

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setErrorMsg('');
    setSuccessMsg('');

    if (!email.trim()) {
      setErrorMsg('Vui lòng nhập Email vào ô trống.');
      return;
    }

    setLoading(true);
    try {
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: `${window.location.origin}/admin/reset-password`, 
      });

      if (error) throw error;

      setSuccessMsg(`Một liên kết đặt lại mật khẩu đã được gửi đến email: ${email}. Vui lòng kiểm tra hộp thư của bạn!`);
      setEmail('');
    } catch (err) {
      setErrorMsg(err?.message || 'Không thể gửi yêu cầu đặt lại mật khẩu.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-amber-900 flex items-center justify-center px-4">
      <div className="absolute top-20 left-20 w-72 h-72 bg-amber-500/20 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 right-20 w-72 h-72 bg-orange-500/20 rounded-full blur-3xl"></div>

      <div className="relative w-full max-w-md">
        <div className="backdrop-blur-xl bg-white/95 border border-white/20 rounded-3xl shadow-2xl p-8">
          
          <div className="flex justify-center mb-6">
            <div className="w-20 h-20 rounded-2xl bg-gradient-to-br from-amber-400 to-orange-500 flex items-center justify-center shadow-lg">
              <svg 
                className="w-10 h-10 text-white" 
                fill="none" 
                stroke="currentColor" 
                strokeWidth="2" 
                viewBox="0 0 24 24" 
                xmlns="http://www.w3.org/2000/svg"
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 5.25a3 3 0 013 3m3 0a6 6 0 01-7.029 5.912c-.563-.097-1.159.026-1.563.43L10.5 17.25H8.25v2.25H6v2.25H2.25v-2.818c0-.597.237-1.17.659-1.591l6.499-6.499c.404-.404.527-1 .43-1.563A6 6 0 1121.75 8.25z" />
              </svg>
            </div>
          </div>

          <div className="text-center mb-8">
            <h1 className="text-3xl font-extrabold text-slate-900 mb-2">
              Quên Mật Khẩu
            </h1>
            <p className="text-slate-500 text-sm leading-relaxed">
              Nhập email hệ thống của bạn, chúng tôi sẽ gửi liên kết để khôi phục quyền truy cập.
            </p>
          </div>

          <form onSubmit={handleForgotPassword} className="space-y-5">
            <div>
              <label className="block text-sm font-semibold text-slate-700 mb-2">
                Email Đăng Ký
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@example.com"
                className="w-full px-4 py-3 rounded-2xl border border-slate-200 bg-slate-50 text-slate-900 placeholder-slate-400 outline-none transition-all duration-200 focus:bg-white focus:border-amber-400 focus:ring-4 focus:ring-amber-100"
                required
                disabled={loading}
              />
            </div>

            {errorMsg && (
              <div className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-2xl px-4 py-3">
                Email không trùng khớp. Vui lòng thử lại Email khác
              </div>
            )}

            {successMsg && (
              <div className="text-sm text-green-700 bg-green-50 border border-green-200 rounded-2xl px-4 py-3 leading-relaxed">
                {successMsg}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              className="w-full py-3.5 rounded-2xl bg-gradient-to-r from-amber-500 to-orange-500 text-white font-bold shadow-lg shadow-amber-500/30 hover:shadow-xl hover:shadow-amber-500/40 hover:scale-[1.02] transition-all duration-200 disabled:opacity-60 disabled:cursor-not-allowed disabled:hover:scale-100"
            >
              {loading ? "Đang gửi yêu cầu..." : "Gửi liên kết khôi phục"}
            </button>
          </form>

          <div className="mt-6 text-center">
            <Link 
              to="/admin/login" 
              className="text-sm font-semibold text-amber-600 hover:text-orange-600 hover:underline transition-colors focus:outline-none inline-flex items-center gap-1"
            >
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-4 h-4">
                <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
              </svg>
              Quay lại đăng nhập
            </Link>
          </div>

          <div className="mt-8 text-center text-xs text-slate-400">
            © 2026 Admin Management System
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminForgotPasswordPage;